import { ConstructClassWithPrivateMembers } from '../../../../misc/helpers/ClassWithPrivateMembers';
import { EVENTS_OBSERVABLE_PRIVATE } from './privates';
import { IsObject } from '../../../../helpers';
export function ConstructEventsObservable(instance, target, name) {
    ConstructClassWithPrivateMembers(instance, EVENTS_OBSERVABLE_PRIVATE);
    const privates = instance[EVENTS_OBSERVABLE_PRIVATE];
    privates.target = target;
    privates.name = name;
    privates.observerListenerMap = new WeakMap();
}
export function IsEventsObservable(value) {
    return IsObject(value)
        && value.hasOwnProperty(EVENTS_OBSERVABLE_PRIVATE);
}
//# sourceMappingURL=constructor.js.map